import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import GridTextField from '../../components/GridTextField';
import Grid from '@material-ui/core/Grid';
import { FormContextValues } from 'react-hook-form';
import FormPeople from '../../types/FormPeople';
import { removeMaskIfBackspace, applyMaskOnChange } from '../../utils';
import moment from 'moment';

interface Props {
  form: FormContextValues<FormPeople>;
  open: boolean;
}

export default function PeopleTabMinistry({
  form,
  open,
}: Props) {
  useEffect(() => {
    form.register({ name: 'consecrated' });
    form.register({ name: 'ministryMode' });
  }, [ form ]);

  const consecrated = form.watch('consecrated');
  const ministryMode = form.watch('ministryMode');

  return (
    <Box hidden={!open}>
      <Grid container spacing={2}>
        <GridTextField
          label='Consagrado'
          gridSize={6}
          options={['Sim', 'Não']}
          value={consecrated}
          onChange={(e: any) => form.setValue('consecrated', e.target.value)}
        />
        <GridTextField
          label='Qual ministério'
          name='consecratedMinistry'
          gridSize={6}
          inputRef={form.register}
        />
        <GridTextField
          label='Igreja que consagrou'
          name='consecratedChurch'
          gridSize={6}
          inputRef={form.register}
        />
        <GridTextField
          label='Data da consagração'
          name='consecratedDate'
          gridSize={3}
          inputRef={form.register({
            validate: value => {
              return !value || moment(value, 'DD/MM/YYYY').isValid() || 'Data inválida';
            },
          })}
          errorMessage={form.errors?.consecratedDate?.message}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('date')}
        />
        <GridTextField
          label='Data de batismo'
          name='baptismDate'
          gridSize={3}
          inputRef={form.register({
            validate: value => {
              return !value || moment(value, 'DD/MM/YYYY').isValid() || 'Data inválida';
            },
          })}
          errorMessage={form.errors?.baptismDate?.message}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('date')}
        />
        <GridTextField
          label='Cargo de liderança'
          name='leadership'
          gridSize={6}
          inputRef={form.register}
        />
        <GridTextField
          label='Qual ministério'
          name='leadershipMinistry'
          gridSize={6}
          inputRef={form.register}
        />
        <GridTextField
          label='Ministério que participa'
          name='ministry'
          gridSize={12}
          inputRef={form.register}
        />
        <GridTextField
          label='Data de entrada'
          name='ministryDate'
          gridSize={6}
          inputRef={form.register({
            validate: value => {
              return !value || moment(value, 'DD/MM/YYYY').isValid() || 'Data inválida';
            },
          })}
          errorMessage={form.errors?.ministryDate?.message}
          onKeyDown={removeMaskIfBackspace}
          onChange={applyMaskOnChange('date')}
        />
        <GridTextField
          label='Modo'
          gridSize={6}
          options={['Aclamação', 'Batismo', 'Transferência']}
          value={ministryMode}
          onChange={(e: any) => form.setValue('ministryMode', e.target.value)}
        />
      </Grid>
    </Box>
  );
}
